
const { removeToken } = require('../token');

const logout = () => removeToken();

module.exports = logout;
